import AbstractView from './AbstractView';

import gsap from 'gsap';
import ScrollManager from '../managers/ScrollManager';
import EmitterManager from '../managers/EmitterManager';
import { REVEALS } from 'core/Events';
import RAF from 'core/RAF';
import { mapRange } from 'gsap/gsap-core';
import { clamp } from 'gsap/gsap-core';

class About extends AbstractView {
  constructor() {
    super(...arguments);
  }

  enter() {
    EmitterManager.emit(REVEALS, this.ui.$about);

    const { $centerImage } = this.ui;
    if ($centerImage) {
      gsap.fromTo(
        $centerImage,
        { x: -75, scale: 0.9, opacity: 0 },
        { x: 0, scale: 1, opacity: 1, duration: 2, delay: 0.2, ease: 'circ.out' }
      );
    }
  }

  initializeBeforeEvents() {
    super.initializeBeforeEvents();

    const { $sections } = this.ui;

    this.sections = $sections.map(($section) => ({
      $el: $section,
      type: $section.dataset.type,
      $image: $section.querySelector('.image'),
      $image_tag: $section.querySelector('.image img'),
      $content: $section.querySelector('.about__content'),
      top: null,
      height: null,
    }));

    console.log(this.sections);

    this.smoothScrollTop = ScrollManager.scrollTop;
  }

  bind() {
    super.bind();
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleRaf = this.handleRaf.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$about = ui.$element.querySelector('.about');
    ui.$centerImage = ui.$element.querySelector('.about__center .image');
    ui.$sections = [...ui.$about.querySelectorAll('.about__center, .about__block')];
    ui.$nexts = [...ui.$about.querySelectorAll('.about__next')];
    return ui;
  }

  events(listen) {
    super.events(listen);
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    const { $nexts } = this.ui;
    $nexts.forEach(($next) => $next[listener]('click', this.handleClickNext));
  }

  handleRaf() {
    const sT = ScrollManager.scrollTop;
    this.smoothScrollTop += (sT - this.smoothScrollTop) * 0.1;

    this.sections.forEach(({ $el, $image_tag, $content, type, top, height }) => {
      const progress = (this.smoothScrollTop - top) / height;

      if (type === 'center') {
        $content.style.opacity = clamp(0, 1, mapRange(0, 0.5, 1, 0, progress));
        $content.style.transform = `translateY(${progress * -150}px)`;
      } else {
        $content.style.opacity = clamp(0, 1, mapRange(-0.6, -0.1, 0, 1, progress));
        $image_tag.style.transform = `scale(${clamp(1, 1.1, mapRange(-0.5, 0, 1.1, 1, progress))})`;
      }
    });
  }

  handleClickNext(event) {
    event.preventDefault();
    const $parent = event.currentTarget.closest('.about__center, .about__block');
    const $next = $parent.nextElementSibling;
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: $next, offsetY: this.header.height - 1 },
    });
  }

  handleScroll(sT = ScrollManager.scrollTop) {
    this.header.hasBackground = sT > this.sections[0].height - this.header.height;
  }

  handleResize() {
    this.sections.forEach((object) => {
      object.top = object.type === 'center' ? 0 : object.$el.offsetTop;
      object.height = object.$el.offsetHeight;
    });
  }

  handleBreakpoint({ isMobile, isTabletPortrait }) {
    const isLightMode = isMobile || isTabletPortrait;

    if (isLightMode) {
      RAF.unsuscribe('about');
      this.sections.forEach(({ $content, $image_tag }) => {
        $content.style.removeProperty('opacity');
        $content.style.removeProperty('transform');
        $image_tag.style.removeProperty('transform');
      });
    } else {
      RAF.suscribe('about', this.handleRaf);
    }

    this.isLightMode = isLightMode;
  }
}

export default About;
